import React, { useEffect, useRef, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from '../../auth/authProvider';

function LoginError(props) {
    const [error, setError] = useState(true);
    const { instance, inProgress } = useMsal();
    const redirectAttempted = useRef(false);

    useEffect(() => {
        if (props) {
            const { error } = props;
            if (error) {
                setError(error);
                console.log("loginRedirectError>>>>", error);
            }
        }
    }, [props]);

    useEffect(() => {
        if (inProgress === InteractionStatus.None && !redirectAttempted.current) {
            redirectAttempted.current = true;
            instance.loginRedirect(loginRequest).catch(e => {
                console.log("loginRedirectError>>>>", e);
                redirectAttempted.current = false;
            });
        }
    }, [inProgress, instance])

    const handleLogin = async () => {
        if (inProgress === InteractionStatus.None) {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log("loginRedirectError>>>>", e);
            });
        }
    }

    return (
        <div>
            {error &&
                <p><span>An error occured during authentication, please try again!</span></p>
            }
            <p>
                <button onClick={() => handleLogin()}>Login</button>
            </p>
        </div>
    );
}

export default LoginError;